import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular/lazy';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { AuthorizationHttpInterceptor } from './core/authorization-http.interceptor';
import { RetryHttpInterceptor } from './core/retry-http.interceptor';
import { AuthProvider } from './services/auth.providers';
import { CurrencyPipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SmartMovingSharedLibModule } from '@smartmoving/sm-shared-lib';
import { environment } from 'src/environments/environment';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { LoginPageModule } from 'src/app/pages/login/login.module';
import { ENV } from 'src/app/app.config';
import { LocalDataStoreAbstract, SmMobileSharedLibModule } from '@smartmoving/sm-mobile-shared-lib';
import { LocalDatastoreService } from 'src/app/services/local-datastore-service';
import { GlobalErrorHandlerService } from 'src/app/services/global-error-handler.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'ios'
    }),
    AppRoutingModule,
    LoginPageModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SmartMovingSharedLibModule.forRoot(environment),
    SmMobileSharedLibModule.forRoot(environment, ENV.version),
    SimpleNotificationsModule.forRoot({
      position: ['top', 'right'],
      timeOut: 3000,
      showProgressBar: false,
      pauseOnHover: true,
      clickToClose: true
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryHttpInterceptor,
      multi: true,
    },
    {
      provide: LocalDataStoreAbstract,
      useClass: LocalDatastoreService
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    HttpClient,
    AuthProvider,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    CurrencyPipe,
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
    // CDK 21 promotes overlays to the native top layer by default, which renders dropdowns behind dialogs.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }
  ],
  bootstrap: [AppComponent],
  schemas:
      [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {}
